import type { BuildFacetGraphParams, ExplodeFlow } from "../types";
import { buildBaseGraph } from "./graph/buildBaseGraph";
import { buildOverlay } from "./graph/buildOverlay";

export { FIELD_FOCUS_TOP_VALUES, OVERLAY_PAGE_SIZE } from "./graph/graphLayout";

export const buildFacetGraph = (params: BuildFacetGraphParams): ExplodeFlow => {
    const base = buildBaseGraph(params);
    if (!params.overlay) return base;

    const dimmedNodes = base.nodes.map((baseNode) => ({
        ...baseNode,
        data: { ...baseNode.data, dimmed: true, focused: false },
    }));
    const fadedEdges = base.edges.map((edge) => ({
        ...edge,
        style: { stroke: "#f4f0fc", strokeWidth: 1 },
    }));

    const overlayFlow = buildOverlay({ overlay: params.overlay, params });
    return {
        nodes: [...dimmedNodes, ...overlayFlow.nodes],
        edges: [...fadedEdges, ...overlayFlow.edges],
    };
};
